import { type locales } from './intlResource';
import { type SupportedLocale } from './intlTypes';

export const ENFORCER = '!';

const normalizeLocaleString = (localeString: string) => localeString.replace('_', '-');

const parse = (localeString: string, enforcer = ENFORCER) => {
  const source = normalizeLocaleString(localeString).trim();
  const DIVIDER = '-';
  const isForced = source.trim().endsWith(enforcer);
  let locale = source;
  if (isForced) [locale] = locale.split(enforcer);
  const [language, country] = locale.split(DIVIDER);
  return {
    isForced,
    locale,
    language,
    country,
  };
};

const generateAliasMap = (supportedLocales: typeof locales) => {
  const tags = Object.keys(supportedLocales) as SupportedLocale[];
  const map = {} as Record<string, string>;
  tags.forEach((tag) => {
    map[tag] = tag;
    const { alias } = supportedLocales[tag];
    if (Array.isArray(alias)) {
      alias.forEach((t) => {
        map[t] = tag;
      });
    }
  });
  return map;
};

const lookup = (
  localeString: string,
  supportedLocales: typeof locales,
  defaultLocale: SupportedLocale,
) => {
  const { locale, language } = parse(localeString);
  const map = generateAliasMap(supportedLocales);
  if (typeof map[locale] === 'string') return map[locale] as SupportedLocale;

  if (typeof map[language] === 'string') return map[language];

  const match = Object.keys(map).find((l) => l.startsWith(`${language}-`));
  if (match) return match as SupportedLocale;

  return defaultLocale;
};

export default {
  generateAliasMap,
  lookup,
  parse,
};
